import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

/**
 * @param {object} params -
 *  action: 'by_customer_checkin', customer_id: int
 * @param {boolean} loading
 */
export async function index(params, loading = true) {
  const axios = loading ? axiosInstance().primoLab : axiosInstanceWithoutLoader().primoLab;
  let prescriptionTests = [];

  await axios
    .get(`/prescription-tests`, {params})
    .then(async (response) => {
      prescriptionTests = response.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { prescriptionTests };
}
